import { StaticImageData } from 'next/image';
import img1 from '../images/firstPage/1-blackwhite.jpeg';
import img2 from '../images/firstPage/2-cloud.jpg';
import img3 from '../images/firstPage/3-wood.jpg';
import img4 from '../images/firstPage/4-plaster.jpg';
import drawing74 from '../images/drawings/new-images-14-feb-2025/1.jpg';
import drawing81 from '../images/drawings/new-images-14-feb-2025/8.jpg';

export type ImageData = {
  src: StaticImageData;
  alt: string;
};

export const HomeImages: ImageData[] = [
  {
    src: img1,
    alt: 'Artpiece made by Karen Oude Alink',
  },
  {
    src: drawing74,
    alt: 'Drawing made by Karen Oude Alink',
  },
  {
    src: img2,
    alt: 'Artpiece made by Karen Oude Alink',
  },
  {
    src: drawing81,
    alt: 'Drawing made by Karen Oude Alink',
  },
  {
    src: img3,
    alt: 'Artpiece made by Karen Oude Alink',
  },
  {
    src: img4,
    alt: 'Artpiece made by Karen Oude Alink',
  },
];
